<template>
  <v-card>
    <v-card-text>
      <v-data-table-server
        v-model="selected"
        select-strategy="all"
        show-select
        :items="data?.data"
        :headers="headers"
        :items-per-page="pageOptions.limit"
        item-key="id"
        :items-length="data?.count || 0"
        :search="pageOptions.q"
        @update:options="handleLimitChange">
        <template v-slot:top>
          <v-text-field
            v-model="pageOptions.q"
            class="ma-2"
            density="compact"
            :placeholder="`Search ${role.role_name}...`"
            hide-details></v-text-field>
        </template>
      </v-data-table-server>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="emit('close')">Cancel</v-btn>
      <v-btn color="primary" @click="updateList">Update</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script setup lang="ts">
import { IPaginationDTO, IRoleDTO, IUserDTO, PaginationDTO } from '@/dtos';
import { useAdminUserStore } from '@/stores/modules/admin';
import { computed, ref } from 'vue';
import type { VDataTableServer } from 'vuetify/components';

interface Props {
  role: IRoleDTO;
  exclude: IUserDTO[];
}

const props = defineProps<Props>();
const emit = defineEmits(['close', 'add']);
const pageOptions = ref<IPaginationDTO>(new PaginationDTO());
const role = ref<IRoleDTO>(props.role);
const selected = ref<string[]>([]);
const exclude = computed(() => props.exclude.map((user) => user.id));

const adminUsersStore = useAdminUserStore();

const { data } = adminUsersStore.getAllUsersByRoleQuery(role, exclude, pageOptions);
const headers = [
  { title: 'First Name', key: 'first_name', align: 'start', sortable: true },
  { title: 'Last Name', key: 'last_name', align: 'start', sortable: true },
  { title: 'Email', key: 'email_address', align: undefined, sortable: true },
  { title: '', key: 'action', align: 'end', sortable: false },
] as const;

const handleLimitChange = async (value: VDataTableServer) => {
  pageOptions.value.buildPagination(value);
};

const updateList = async () => {
  emit('add', selected.value);
};
</script>
